export default "__VITE_ASSET__fc682f45__"